<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Thêm mới danh mục tin tức</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="12">
          <el-form label-position="right" :model="modelData" ref="createModel" label-width="135px" @submit.native.prevent>
            <el-form-item prop="name" label="Tên danh mục" class="form-item"
              :rules="[
                { required: true, message: 'Vui lòng nhập tên danh mục', trigger: 'blur' }
              ]">
              <el-input v-model="modelData.name" class="input-seach" ref="myInput"></el-input>
            </el-form-item>
            <el-form-item prop="type" label="Nhóm menu" class="form-item"
              :rules="[
                { required: true, message: 'Vui lòng chọn nhóm menu', trigger: 'blur' }
              ]">
              <el-select v-model="modelData.type" filterable placeholder="Nhóm menu" class="input-select">
                <el-option
                  v-for="item in lists.listUserType"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="parant_id" label="Nhóm danh mục" class="form-item" v-if="modelData.type == 6">
              <el-select v-model="modelData.parant_id" filterable placeholder="Chọn danh mục" class="input-select">
                <el-option
                  v-for="item in listCategories"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="priority" label="Vị trí ưu tiên" class="form-item">
              <el-input v-model="modelData.priority" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item prop="slug" label="SEO Link" class="form-item">
              <el-input v-model="modelData.slug" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item prop="seo_title" label="SEO Tiêu đề" class="form-item">
              <el-input v-model="modelData.seo_title" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item prop="seo_description" label="SEO Mô tả ngắn" class="form-item">
              <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 5}" v-model="modelData.seo_description" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item prop="seo_tag" label="SEO từ khóa" class="form-item">
              <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 5}" v-model="modelData.seo_tag" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="success"
                  size="small"
                  @click="submitForm('createModel')"
                  native-type="submit">Lưu lại</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'CategoryCreate',
  metaInfo () {
    return {
      title: 'Danh mục tin tức'
    }
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        name: '',
        parant_id: 0,
        type: '',
        slug: '',
        seo_title: '',
        seo_description: '',
        seo_tag: '',
        status: true
      },
      listCategories: [],
      lists: {
        listStatus: [
          {key: 1, value: 'Kích hoạt'},
          {key: 0, value: 'Chưa kích hoạt'}
        ],
        listUserType: [
          {key: 1, value: 'Giới thiệu'},
          {key: 2, value: 'Tuyển sinh'},
          {key: 3, value: 'Giải trí chia sẻ'},
          {key: 4, value: 'Hướng dẫn'},
          {key: 5, value: 'Kiểm định'},
          {key: 6, value: 'Du học'},
          {key: 7, value: 'Tin tức - Video'},
          {key: 8, value: 'Chứng chỉ'},
          {key: 9, value: 'Đào tạo'},
          {key: 10, value: 'Khoa - ban'},
          {key: 11, value: 'Trung tâm'},
          {key: 12, value: 'Tuyển sinh Ehuni'}
        ]
      }
    }
  },
  mounted () {
    this.$refs.myInput.focus()
    this.configBreadcrumb()
    this.fetchListCategories()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'category-blogs-index', text: 'Danh mục tin tức' },
        { name: 'category-blogs-create', text: 'Thêm mới' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'category-blogs-index'})
    },
    sanitizeTitle: function (title) {
      var slug = ''
      var titleLower = title.toLowerCase()
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e')
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a')
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o')
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u')
      slug = slug.replace(/i|í|ì|ỉ|ị|ĩ/gi, 'i')
      slug = slug.replace(/đ/gi, 'd')
      slug = slug.replace(/y|ý|ỳ|ỹ|ỵ|ỷ/gi, 'y')
      slug = slug.replace(/\s*$/g, '')
      slug = slug.replace(/\s+/g, '-')

      return slug
    },
    // Tải dữ liệu
    fetchListCategories () {
      axios.get('category-blogs/get-recursive-category-blogs').then(response => {
        switch (response.code) {
          case 200:
            this.listCategories = response.data.categories
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          console.log('Lỗi validate')
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.post('category-blogs', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Thêm danh mục thành công',
              type: 'success'
            })
            this.$router.push({name: 'category-blogs-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  },
  watch: {
    'modelData.name': function () {
      this.modelData.slug = this.sanitizeTitle(this.modelData.name)
    },
    'modelData.type': function () {
      if (this.modelData.type !== 6) {
        this.modelData.parant_id = 0
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/category-blogs/Create.vue